
import actions from '../../actions-list';
import {getDefaultState as getDuplicatePinPlateDefaultState} from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';

export const updatePIN = pin =>

    dispatch =>

        dispatch({
            pin,
            type: actions.UPDATE_DUPLICATE_PIN_PLATE_PIN
        });

export const updateDuplicatePinPlate = (property, value) =>

    dispatch =>

        dispatch({
            property,
            type: actions.UPDATE_DUPLICATE_PIN_PLATE_INFORMATION,
            value
        });

export const updateMachineModel = machineModel =>

    dispatch =>

        dispatch({
            machineModel,
            type: actions.UPDATE_DUPLICATE_PIN_PLATE_MACHINE_MODEL
        });

export const updateRequesterTSCM = requesterTCSM =>

        dispatch =>

            dispatch({
                requesterTCSM,
                type: actions.UPDATE_DUPLICATE_PIN_PLATE_REQUESTER_TCSM
            });

export const updateMissingPlateReason = missingPlateReason =>

            dispatch =>

                dispatch({
                    missingPlateReason,
                    type: actions.UPDATE_DUPLICATE_PIN_PLATE_MISSING_PLATE_REASON
                });

export const updateDealerLocation = account => ({
    account,
    type: actions.UPDATE_DUPLICATE_PIN_PLATE_DEALER_LOCATION
});

export const updateMailingRecipient = mailingRecipient =>

                dispatch =>

                    dispatch({
                        mailingRecipient,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_MAILING_RECIPIENT
                    });

export const updateAddressLine1 = address1 =>

                dispatch =>

                    dispatch({
                        address1,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_ADDRESS1
                    });

export const updateAddressLine2 = address2 =>

                dispatch =>

                    dispatch({
                        address2,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_ADDRESS2
                    });

export const updateCity = city =>

                dispatch =>

                    dispatch({
                        city,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_CITY
                    });

export const updateZipCode = postalCode =>

            dispatch =>

                dispatch({
                    postalCode,
                    type: actions.UPDATE_DUPLICATE_PIN_PLATE_ZIP_CODE
                });

export const updateState = state =>

                dispatch =>

                    dispatch({
                        state,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_STATE
                    });

export const updateCountry = country =>

                dispatch =>

                    dispatch({
                        country,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_COUNTRY
                    });

export const updatePhone = phone =>

                dispatch =>

                    dispatch({
                        phone,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_PHONE
                    });

export const updateInstructions = instruction =>

                dispatch =>

                    dispatch({
                        instruction,
                        type: actions.UPDATE_DUPLICATE_PIN_PLATE_INSTRUCTIONS
                    });

export const resetDuplicatePinPlate = () =>

    dispatch =>

        dispatch({
            data: getDuplicatePinPlateDefaultState(),
            type: actions.RESET_DUPLICATE_PIN_PLATE
        });

export const addFile = file => ({
    file,
    type: actions.UPDATE_DUPLICATE_PIN_PLATE_FILE
});



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/duplicate-pin-plate.js